<template>
  <div class="l-main">
    <div class="main-box">
      <div class="title">
        <img :src="`${staticPath}img/login/logo_title.png`">
      </div>
      <div class="control">
        <input type="text" v-model="userId" placeholder="ユーザーID" class="control__input">
        <input type="password" v-model="passwd"  placeholder="パスワード" class="control__input">
        <p class="control__message">{{ message }}</p>
        <div class="control__btn" v-on:click="login">
          <img :src="`${staticPath}img/login/btn_login.png`">
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="logo">
        <img :src="`${staticPath}img/login/logo_mazda.png`">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/login.scss';
</style>

<script>
  import Constant from '@/constant';

  export default {

    data() {
      return {
        staticPath: Constant.STATICPATH,
        userId: '',
        passwd: '',
        message: ''
      }
    },

    methods: {
      
      login(){

        if (! this.userId || ! this.passwd) {
          this.message = 'ユーザID・パスワードを入力してください';
          return;
        }

        if (! (this.userId == 'test' && this.passwd == 'test')) {
          this.message = 'ユーザID・パスワードが違います';
          return;
        }

        this.$router.push({ name: 'Mode' }) 
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/PageLogin.vue